var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91667 0L2.5 0.416667H0V1.25H0.46224L1.20524 7.60661V7.60986C1.25983 8.02097 1.6168 8.33333 2.03125 8.33333H5.46794C5.88239 8.33333 6.23935 8.02097 6.29395 7.60986L6.29476 7.60661L7.03776 1.25H7.5V0.416667H5L4.58333 0H2.91667ZM1.30208 1.25H6.19792L5.46794 7.5H2.03125L1.30208 1.25Z",
    fill: "#858EBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinIcon);
export default __webpack_public_path__ + "static/media/BinIcon.25a6ac2fa55782e83703f7f698724e43.svg";
export { ForwardRef as ReactComponent };